import { render } from "./CompleteRegistration.vue?vue&type=template&id=52c2400c&scoped=true"
import script from "./CompleteRegistration.vue?vue&type=script&lang=js"
export * from "./CompleteRegistration.vue?vue&type=script&lang=js"

import "./CompleteRegistration.vue?vue&type=style&index=0&id=52c2400c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c2400c"]])

export default __exports__